import React from 'react';
import {Text, Viewport, useDevice} from '../../Atoms';
import {Inline, Stack} from '../../Layout';
import styles from './ReferralFAQSection.module.css';
import {FAQs} from '../FAQs';
import {splitToParagraphs} from '../../../utils/splitToParagraphs/splitToParagraphs';
import clsx from 'clsx';

export type FAQ = {
  question: string;
  answer: string;
};

export type ReferralFAQProps = {
  title: string;
  body: React.ReactNode;
  faqs: FAQ[];
  showAllFAQsButtonLabel: string;
  className?: string;
};

export const ReferralFAQSection = ({
  title,
  body,
  faqs,
  showAllFAQsButtonLabel,
  className,
}: ReferralFAQProps) => {
  const {isMobile, isDesktop} = useDevice();

  const faqClassName = clsx(styles.faqSection, className);

  const Content = () => (
    <>
      <Stack space={isDesktop ? 'lg' : 'sm'} className={styles.faqDescription}>
        <Text type={isDesktop ? 'mdHero' : 'smHero'} as="h2">
          {title}
        </Text>
        {body}
      </Stack>
      <div className={styles.faqs}>
        <FAQs
          faqs={faqs.map(({question, answer}, index) => ({
            id: `faq-${index}`,
            title: question,
            content: splitToParagraphs(answer).map((paragraph, index) => (
              <Text
                key={index}
                as="p"
                type={isDesktop ? 'body' : 'caption'}
                className={
                  isDesktop ? styles.faqParagraphDesktop : styles.faqParagraph
                }
              >
                {paragraph}
              </Text>
            )),
          }))}
          showAllFAQsButtonLabel={showAllFAQsButtonLabel}
        />
      </div>
    </>
  );

  return (
    <div className={styles.root}>
      <Viewport device={['mobile', 'tablet']} serverRender={isMobile}>
        <Stack space="lg" className={faqClassName}>
          <Content />
        </Stack>
      </Viewport>
      <Viewport device={'desktop'} serverRender={isDesktop}>
        <Inline space="2xl" align="start" className={faqClassName}>
          <Content />
        </Inline>
      </Viewport>
    </div>
  );
};
